import { UserRoles } from './interfaces';

// Who can enter the app at all
export const ROLES_WITH_APP_ACCESS = [UserRoles.ADMINS, UserRoles.OPERATOR, UserRoles.ENGINEER];

// Who can view the devices page
export const ROLES_WITH_DEVICE_VIEW = [UserRoles.ADMINS, UserRoles.OPERATOR, UserRoles.ENGINEER];

// Who can create devices, change version, or attach an organization
export const ROLES_WITH_DEVICE_MANAGE = [UserRoles.ADMINS, UserRoles.ENGINEER];

// Who can view, create, and edit route cards
export const ROLES_WITH_ROUTE_CARD_ACCESS = [UserRoles.ADMINS, UserRoles.OPERATOR, UserRoles.ENGINEER];

// Admin-only sections
export const ROLES_WITH_MAPS_ACCESS = [UserRoles.ADMINS];
export const ROLES_WITH_TILES_VIEWER_ACCESS = [UserRoles.ADMINS];
export const ROLES_WITH_CONFIGURATIONS_ACCESS = [UserRoles.ADMINS];
export const ROLES_WITH_ORGANIZATIONS_ACCESS = [UserRoles.ADMINS];
export const ROLES_WITH_HARDWARE_CONFIG_ACCESS = [UserRoles.ADMINS];
export const ROLES_WITH_ONLINE_PEERS_ACCESS = [UserRoles.ADMINS];
